import { createElement, styled, compose, position, space, layout, flexbox, color, typography, border, opacity, float, boxShadow, pointerEvents, boxSizing, visibility, transition, textOverflow, textDecoration, textTransform, outline, cursor, whiteSpace, wordWrap } from '@vebox/etui-system';

const ThElement = createElement('th');
const Th = styled(ThElement)(compose(position, space, layout, flexbox, color, typography, border, opacity, float, boxShadow, pointerEvents, boxSizing, visibility, transition, textOverflow, textDecoration, textTransform, outline, cursor, whiteSpace, wordWrap));
Th.displayName = 'Th';

export { Th };
